import { render } from "./NotificationsChatbot.vue?vue&type=template&id=842a5fb0&scoped=true"
import script from "./NotificationsChatbot.vue?vue&type=script&lang=js"
export * from "./NotificationsChatbot.vue?vue&type=script&lang=js"

import "./NotificationsChatbot.vue?vue&type=style&index=0&id=842a5fb0&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-842a5fb0"]])

export default __exports__